const initializeBackgroundImage = () => {
  $(".bg-image").each(function forBgImage() {
    const bgData = $(this).attr("data-bg-src");
    $(this).css("background-image", `url("${bgData}")`);
  });
};

export default initializeBackgroundImage;
